import { PropertyTeaserType } from 'store/properties/types';
import { FC, memo, useCallback, useMemo } from 'react';
import { Container } from 'react-bootstrap';
import { PropertySubsectionTitle } from './property-subsection-title';
import { PropertyPartnersTable } from './property-partners-table';
import { ReactComponent as PeopleSvg } from "assets/ic_outline-people.svg";
import classNames from 'classnames';
import { Videos } from 'new-architecture/components/videos';
import { useTrackTeaserProductVideoOpenedMutation } from 'api/analitics';

import styles from './style.module.scss';

interface PropertyPartnersProps {
  property: PropertyTeaserType
}

const tableClass = classNames(styles.wrapper__partners);

export const PropertyPartners: FC<PropertyPartnersProps> = memo(({ property }) => {
  const { roles, rolesVideos } = useMemo(() => {
    const { securityAndRoles, sectionAssets } = property;
    const { roles: rolesVideos } = sectionAssets || {};
    const { roles, aboutThePartner } = securityAndRoles;
    const { text, image } = aboutThePartner || {};

    return { roles, text, image, rolesVideos: rolesVideos || [] };
  }, [property]);

  const [trackProductVideoOpened] = useTrackTeaserProductVideoOpenedMutation();
  const onOpenVideo = useCallback((videoUrl: string) => {
    trackProductVideoOpened({
      opportunity: property.name,
      opportunityId: property._id,
      productVideoUrl: videoUrl
    });
  }, [trackProductVideoOpened, property]);

  return (
    <div className={styles.wrapper}>
      <Container>
        <PropertySubsectionTitle
          icon={<PeopleSvg />}
          title={"Roles"}
        />
        <Videos videos={rolesVideos || []} onOpenVideo={onOpenVideo} />
      </Container>

      <Container
        className={
          styles['partners-table-container']
        }
      >
        <div className={tableClass}>
          <PropertyPartnersTable roles={roles} />
        </div>
      </Container>
    </div>
  );
})
